export const roomRateAvailabilityQueryKeys = {
  all: ['roomRateAvailability'] as const,
  detail: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, propertyId, roomTypeId, roomRateId] as const,
  // Per-resource keys, so a mutation in one sub-tab (e.g. blackouts) only invalidates its own resource for this
  // room type/rate, not every other sub-tab's queries across every room type/rate in the offer.
  blackout: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'blackout', propertyId, roomTypeId, roomRateId] as const,
  surcharge: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'surcharge', propertyId, roomTypeId, roomRateId] as const,
  internalSurcharge: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'internalSurcharge', propertyId, roomTypeId, roomRateId] as const,
  capacities: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'capacities', propertyId, roomTypeId, roomRateId] as const,
  includedGuests: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'includedGuests', propertyId, roomTypeId, roomRateId] as const,
  extraGuestSurcharges: (propertyId: string, roomTypeId: string, roomRateId: string) =>
    [...roomRateAvailabilityQueryKeys.all, 'extraGuestSurcharges', propertyId, roomTypeId, roomRateId] as const,
};

export interface AvailabilityBlock {
  range: [string, string];
  count: number;
  total: number;
}

export interface DateFlagBlock {
  start_date: string;
  end_date: string;
  restriction_type?: string;
  [dayOfWeek: string]: unknown;
}
